import { type FC } from 'react'
import 'swiper/css'
import EmailVerificationForm from '~/components/auth/EmailVerificationForm'
import { SiteLayout } from '~/components/layout/SiteLayout'

const Page: FC = () => {
  return (
    <SiteLayout disableLogoLink>
      <EmailVerificationForm />
    </SiteLayout>
  )
}

export default Page
